import React, { useState } from "react";
import { Grid } from "@mui/material";
import ByzMuiTypography from "../inputs/ByzMuiTypography";
//MPOGLU;443876;26022025
type DayKey = "previous" | "today" | "next";
interface ByzDaySelectButtonProps {
  previousText: string;
  todayText: string;
  nextText: string;
  onChange?: (day: DayKey) => void;
}

const ByzDaySelectButton: React.FC<ByzDaySelectButtonProps> = ({
  previousText,
  todayText,
  nextText,
  onChange,
}) => {
  const [selected, setSelected] = useState<DayKey>("today");

  const handleItemClick = (day: DayKey) => {
    setSelected(day);
    if (onChange) {
      onChange(day); // ← seçimi dışarıya bildir
    }
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        borderRadius: "4px",
        border: "1px solid #E5E8EB",
        background: "#FBFBFB",
        padding: "4px",
        display: "inline-flex", 
      }}
    >
      {[
        { key: "previous" as DayKey, label: previousText },
        { key: "today" as DayKey, label: todayText },
        { key: "next" as DayKey, label: nextText },
      ].map(({ key, label }) => (
        <Grid
          item
          sx={{ textAlign: "center", flexGrow: 1, minWidth: 0 }}
          key={key}
        >
          <ByzMuiTypography
            onClick={() => handleItemClick(key)}
            sx={{
              width: "100%",
              borderRadius: "8px",
              cursor: "pointer",
              marginLeft: "0px",
              padding: "0px 10px",
              userSelect: "none",
              color: selected === key ? "#000" : "#6C6C6C",
              backgroundColor: selected === key ? "#fff" : "transparent",
              boxShadow:
                selected === key
                  ? "0px 2px 4px 0px rgba(112, 112, 112, 0.15)"
                  : "none",
              fontWeight: 700,
              transition: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            {label}
          </ByzMuiTypography>
        </Grid>
      ))}
    </Grid>
  );
};

export default ByzDaySelectButton;